'use client';

import React, { useState } from 'react';
import { Box, Flex, Button } from '@skin-seoul/design-system';
import TopRankedCategoryFilter from './components/TopRankedCategoryFilter';
import TopRankedProductGrid from './components/TopRankedProductGrid';
import TopRankedProductGridSkeleton from './components/TopRankedProductGridSkeleton';
import SectionContainer from '@/components/shared/SectionContainer';
import { SafeLink } from '@/components/ui/SafeLink';
import { QueryBoundary } from '@/components/ui/QueryBoundary';
import TopRankedCategoryFilterSkeleton from './components/TopRankedCategoryFilterSkeleton';
import { getCurrentMonthName } from '@skin-seoul/utils';
import SectionHeader from '@/containers/home/components/SectionHeader';
import { useRegionCurrency } from '@skin-seoul/service';
interface TopRankedSectionClientProps {
  initialCategoryName?: string;
}
const TopRankedSectionClient = ({
  initialCategoryName
}: TopRankedSectionClientProps) => {
  const {
    currency
  } = useRegionCurrency();
  const currentMonth = getCurrentMonthName();
  const [selectedCategoryName, setSelectedCategoryName] = useState<string | undefined>(initialCategoryName);
  const handleCategoryChange = (categoryName: string) => {
    setSelectedCategoryName(categoryName);
  };
  return <SectionContainer containerInnerProps={{
    background: 'primary.700'
  }} data-sentry-element="SectionContainer" data-sentry-component="TopRankedSectionClient" data-sentry-source-file="TopRankedSection.client.tsx">
      <Flex direction="column" width="100%" gap={6} data-sentry-element="Flex" data-sentry-source-file="TopRankedSection.client.tsx">
        <SectionHeader theme="dark" title={`Top Ranked In ${currentMonth}`} subtitle="Based solely on thousands of reviews & ratings from Korea" data-sentry-element="SectionHeader" data-sentry-source-file="TopRankedSection.client.tsx" />

        <Box width="100%" overflowX="auto" css={{
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': {
          display: 'none'
        }
      }} data-sentry-element="Box" data-sentry-source-file="TopRankedSection.client.tsx">
          <QueryBoundary clientOnly loadingFallback={<TopRankedCategoryFilterSkeleton />} data-sentry-element="QueryBoundary" data-sentry-source-file="TopRankedSection.client.tsx">
            <TopRankedCategoryFilter selectedCategoryName={selectedCategoryName} onCategoryChange={handleCategoryChange} currency={currency} data-sentry-element="TopRankedCategoryFilter" data-sentry-source-file="TopRankedSection.client.tsx" />
          </QueryBoundary>
        </Box>

        <QueryBoundary clientOnly loadingFallback={<TopRankedProductGridSkeleton />} data-sentry-element="QueryBoundary" data-sentry-source-file="TopRankedSection.client.tsx">
          <TopRankedProductGrid selectedCategoryName={selectedCategoryName} currency={currency} data-sentry-element="TopRankedProductGrid" data-sentry-source-file="TopRankedSection.client.tsx" />
        </QueryBoundary>

        <Flex justifyContent="center" width="100%" data-sentry-element="Flex" data-sentry-source-file="TopRankedSection.client.tsx">
          <SafeLink unstyled href="/shop/?orderby=date" width={{
          base: 'full',
          tablet: '332px'
        }} data-sentry-element="SafeLink" data-sentry-source-file="TopRankedSection.client.tsx">
            <Button backgroundColor="transparent" border="1px solid" borderColor="generic.0" borderRadius="8px" color="generic.0" textStyle="paragraph.small" fontWeight="regular" height="48px" width={{
            base: 'full',
            tablet: '332px'
          }} _hover={{
            backgroundColor: 'primary.500'
          }} _active={{
            backgroundColor: 'primary.300',
            borderColor: 'primary.300'
          }} alignSelf="center" data-sentry-element="Button" data-sentry-source-file="TopRankedSection.client.tsx">
              View all
            </Button>
          </SafeLink>
        </Flex>
      </Flex>
    </SectionContainer>;
};
export default TopRankedSectionClient;